import React  from 'react'; 
import ChatbotSvg from '../../../_assets/sass/pages/chatbot/logochat.png';
import {  useIntl } from "react-intl";

const BCheck = (props) => {
  const {msg,sendNewMsg} = props;
  const intl = useIntl();
  const bdata = Array.isArray(msg) ? msg[0] : msg;
  return (
    <>

      <span className="message message2">
        <span className="tuser">
          <img src={ChatbotSvg} width="30px" alt="Chatbot Icon" /> {intl.formatMessage({ id: "CHAT.KOREKSUPPORT" })}
        </span>
        <div className="tdata">
           {bdata.message} <br />
          <span className="time">{bdata.time} </span> 
        </div>

        <div className="tab-buttons">
          {bdata && bdata.services && bdata.services.slice(0, 2).map((service) => (
          <button key={service.id}  onClick={(e) => {
                e.stopPropagation(); 
                sendNewMsg(bdata.parentId,service.id,"");
              }}>
          {service.name}
        </button>
      ))}
        </div>
      </span>

    
    </>
  );
}


export default BCheck;
